// 俄语
export default {
    header_menu: {
        home: "Главная",
        about: "О нас",
        product: "Продукты",
        news: "Новости",
        news_content: "Подробности новости",
        download: "Центр загрузки",
        contact: "Связаться с нами",
    },
    read_more: "Читать далее",
    prev: "Предыдущая статья",
    next: "Следующая статья",
    quick_navigation: "Быстрая навигация",
    phone: "Телефон",
    whatsapp: "WhatsApp",
    email: "Электронная почта",
    address: "Адрес",
    your_name: "Ваше имя",
    your_email: "Ваш e-mail",
    content: "Содержание",
    please_input: "Пожалуйста, введите ",
    leave_message: "Отправить запрос",
    leave_success: "Сообщение успешно отправлено",
    click_count: "Количество кликов",
    create_time: "Время создания",
    upload_time: "Время загрузки",
    //下载（动作）
    download: "Скачать",
    resources: "Ресурсы",
    products_type1: "Категории продукции",
    products_type2: "Подкатегории",
    products_type3: "Подкатегории",
    products_list: "Список продуктов",
    products_detail: "Детали продукта",
    products_video: "Видео продукта",
    send_message: "Отправить запрос",
    products_content: "Содержание продукта",
    categories: "Категории",
    send_email: "Отправить email",
    call_time: "Часы работы",
    our_location: "Наше местоположение",
    leave_message_to_us: "Отправьте нам запрос",
    left_category: "Категории",
    type_two: "Подкатегории",
    type_three: "Подкатегории",
    video_not_support: "Ваш браузер не поддерживает тег video.",
    about_us: "О нас",
    no_data: "Нет данных",
    home_about_subtitle: "Надёжный поставщик премиальной древесины и фанеры для покупателей по всему миру",
    home_products_title: "Наша продукция",
    home_products_subtitle: "Изучите наши ключевые категории продукции",
    view_all: "Смотреть все",
    home_stat_countries: "Страны поставок",
    home_stat_capacity: "Годовой объём (м³)",
    home_stat_years: "Лет опыта",
    home_stat_clients: "Клиенты по всему миру",
    footer_follow: "Подпишитесь на WeChat",
    footer_wechat: "WeChat",
    footer_copyright: "Debai Wood. Все права защищены.",
    home_visual_year: "С 2009 года",
    home_visual_quote: "Надёжный партнёр по премиальной древесине и фанере для покупателей в 60+ странах.",
    home_visual_tag: "FSC · ISO 9001 · CE сертифицировано",
    cta_title: "Ищете надёжного поставщика древесины и фанеры?",
    cta_sub: "Получите конкурентоспособную смету и мировую доставку для ваших оптовых заказов древесины.",
    get_a_quote: "Получить расчёт",
    home_banner_title: "Премиальная древесина и фанера для всего мира",
    home_banner_sub: "Надёжный поставщик по всему миру, обслуживающий 60+ стран с сертифицированным качеством FSC, ISO 9001 и CE.",
    topbar_slogan: "Премиальная древесина и фанера — надёжный выбор покупателей по всему миру",
    contact_hero_tag: "Свяжитесь с нами",
    page_title: {
        home: "Debai Wood | Производитель и поставщик древесины и фанеры",
        about: "О нас | Debai Wood",
        products: "Продукция | Debai Wood",
        news: "Новости | Debai Wood",
        download: "Центр загрузок | Debai Wood",
        contact: "Связаться с нами | Debai Wood",
        not_found: "Страница не найдена",
        back_home: "На главную",
    },
    page_desc: {
        home: "Debai Wood — ведущий производитель и поставщик древесины и фанеры, работающий в 60+ странах с сертификатами FSC, ISO 9001 и CE и доставкой по всему миру.",
        about: "Узнайте о Debai Wood — надежном производителе древесины и фанеры с 15-летним опытом, глобальными клиентами и сертифицированным менеджментом качества.",
        products: "Ознакомьтесь с ассортиментом древесины и фанеры Debai Wood: ламинированная фанера, OSB, MDF, пиломатериалы и индивидуальные решения для мировых покупателей.",
        news: "Последние новости, выставки и отраслевая аналитика от Debai Wood — вашего надежного партнера по древесине и фанере.",
        download: "Скачайте каталоги продукции Debai Wood, сертификаты (FSC, ISO 9001, CE) и технические спецификации по древесине и фанере.",
        contact: "Свяжитесь с Debai Wood для конкурентных цен на оптовые заказы древесины и фанеры. Доставка по всему миру и поддержка B2B.",
    },
}
